<div style="background-color: rgba(255, 255, 0, 0.274); padding: 10px; margin-bottom: 4px; text-align: center">Work in progress</div>

<section class="no-print fourd-design content-container">
  <div class="flex" style="align-items: baseline">
    <h2 class="flex-1">Outcome Insights</h2>
  </div>
</section>

@defer (when buildings()) {
<section class="fourd-design content-container mb-1">
  <div class="no-print">
    <app-toolbar>
      <div class="left">
        @if (isGettingBuilding()) {
          <app-button [label]="building()?.title || 'Please wait'" [isDisabled]="true" [isMuted]="true" icon="mdi mdi-loading mdi-spin-x2" iconPos="right" />
        } @else {
          <app-button [label]="building()?.title || 'Select Building'" (click)="dialogOpen.set('buildings')"> </app-button>
        }
      </div>
      <div class="right"></div>
    </app-toolbar>
    @if (dialogOpen() === 'buildings') {
      <app-dialog header="Select a building" [canScroll]="true" (onClose)="buildingChange(null)">
        <table class="table table-hover" aria-label="Buildings">
          <thead>
            <tr>
              <th colspan="1">Building</th>
              <th colspan="3">Address</th>
            </tr>
          </thead>
          <tbody>
            @for (building of previousBuildings(); track building.id) {
              <tr class="not-selectable">
                <td colspan="4">Previous building</td>
              </tr>
              <tr (click)="buildingChange({ id: building.id, title: building.title })">
                <td>{{ building.title }}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr class="not-selectable">
                <td colspan="4">All Buildings</td>
              </tr>
            }
            @for (building of buildings(); track building.id) {
              <tr (click)="buildingChange(building)">
                <td>{{ building.title }}</td>
                <td>{{ building.site.address.addressTown }}</td>
                <td>{{ building.site.address.addressCounty }}</td>
                <td>{{ building.site.address.addressPostcode }}</td>
              </tr>
            }
          </tbody>
        </table>
      </app-dialog>
    }
  </div>

  @if (buildingForReport()) {
    <div class="mt-1 no-print">
      <table class="table" aria-label="Buildings">
        <thead>
          <tr>
            <th>Building</th>
            <th>Address</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ buildingForReport().title }}</td>
            <td>{{ buildingForReport().site.address.address1 }}</td>
          </tr>
        </tbody>
      </table>

      <div>
        <section>
          @if (buildingForReport().openingHours.isSet) {
            <table class="table can-click">
              <thead>
                <tr>
                  <th>Monday</th>
                  <th>Tuesday</th>
                  <th>Wednesday</th>
                  <th>Thursday</th>
                  <th>Friday</th>
                  <th>Saturday</th>
                  <th>Sunday</th>
                </tr>
              </thead>
              <tr>
                @for (day of buildingForReport().openingHours.hours; track day) {
                  <td>
                    @if (!day.isClosed) {
                      <span>{{ day.from }} - {{ day.to }}</span>
                    }
                    @if (day.isClosed) {
                      <span>Closed</span>
                    }
                  </td>
                }
              </tr>
            </table>
          } @else {
            <div>
              <p>No hours set for the building, please update the building hours to continue.</p>
            </div>
          }
        </section>
      </div>
    </div>
  } @else {}

    @if (buildingForReport()?.openingHours.isSet) {
      <section class="dates">
        <h2>Period 1</h2>
        <div class="flex">
          <div class="">
            <app-calendar [value]="p1_start" (onSelectDate)="p1_start = $event" />
          </div>
          <div class="">
            <app-calendar [value]="p1_end" (onSelectDate)="p1_end = $event" />
          </div>
        </div>
        <h2>Period 2</h2>
        <div class="mt-1 flex">
          <div class="">
            <app-calendar [value]="p2_start" (onSelectDate)="p2_start = $event" />
          </div>
          <div class="">
            <app-calendar [value]="p2_end" (onSelectDate)="p2_end = $event" />
          </div>
        </div>
      </section>

      <section class="no-print actions pb-1">
        <div class="mt-1 mb-1 text-center">
          <app-button (click)="generate()" [isCTA]="true" [isDisabled]="runReport && !reportWasGenerated" [label]="!runReport || reportWasGenerated ? 'Generate Report' : 'Generating report...'" icon="mdi mdi-chart-areaspline-variant" />

          @if (reportWasGenerated) {
            <app-button (click)="printPage()" label="Print Report" icon="mdi mdi-printer" />
          }
        </div>
        @if (reportWasGeneratedAt) {
          <div class="text-right gray">Report generated: {{ reportWasGeneratedAt | amDateFormat: 'DD MMM YYYY' }}</div>
        }
      </section>
    }

    @if (reportWasGenerated) {
      @if (report) {
        <app-insights-floors-report [reportData]="report" />
      }
      <pre style="height: 100px; overflow: scroll; background-color: #e0e0e0">{{ response }}</pre>
    }
  </section>
  <footer #bottomMarker></footer>
  } @placeholder {
  <div class="content-container">
    <i class="mdi-loading mdi mdi-spin-x2"></i>
  </div>
}
